import React from 'react';
import 'antd/dist/antd.css';
import { Space, Spin } from 'antd';
import Loader from './Loader';

const DefaultsLoad = () => {
    return (
        <div
            style={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Space size="middle">
                <Loader />
            </Space>
        </div>
    );
};

export default DefaultsLoad;
